'use strict';

var detailsBase = require('base/product/detail');
var baseModule = require('./base');

var matchBreakpoints = require('../util/matchBreakpoints');

/**
 * Generates the modal window on the first call.
 * @param {string} id - the id adding to events
 */
function getModalHtmlElement(id) {
    if ($('#' + id).length !== 0) {
        $('#' + id).remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="' + id + '" role="dialog">'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">'
        + '        <span>&times;</span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body" tabindex="0"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

detailsBase.fixedATCscroll = function () {
    if (matchBreakpoints(['default', 'sm-up'])) {
        // Calculate the stop from the top of the container, which is always static,
        // to ensure proper positioning when recalculating while the button is sticky
        var $container = $('.js-product-detail-cta-container');
        if ($container.length ) {
            var $button = $('.prices-add-to-cart-actions');
            var $window = $(window);
            var stop;
            var calculateStop = function () {
                stop = $container.offset().top;
                if ($window.scrollTop() >= stop) {
                    $button.addClass('sticky');
                } else {
                    $button.removeClass('sticky');
                }
            };

            calculateStop();

            $(window).on('resize', calculateStop);
            $(document).on('scroll', calculateStop);
        }
    }
};

detailsBase.sizeChart = function () {
    var $sizeChart = $('#sizeChartModal');
    $('.size-chart button').on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('data-href');
        if (!$sizeChart.length) {
            getModalHtmlElement('sizeChartModal');
            $sizeChart = $('#sizeChartModal');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $sizeChart.attr('aria-modal', 'true').attr('aria-label', 'Size chart');
                    $sizeChart.find('.modal-body').html(data.content);
                    $sizeChart.find('.modal-header').prepend('<h2 class="modal-title">Size Chart</h2>');
                }
            });
        }
        $sizeChart.modal('show');
        $(document).on('click', '#sizeChartModal .close', function () {
            $('.size-chart-link').focus();
            setTimeout(function () {
                $(window).scrollTop($('.size-chart-link').position().top);
            }, 500);
        });
    });

    $('body').on('click touchstart', function (e) {
        if ($('.size-chart').has(e.target).length <= 0) {
            $sizeChart.removeClass('active');
        }
    });
};

detailsBase.updateAddToCart = function () {
    $('body').on('product:updateAddToCart', function (e, response) {
        // update local add to cart (for sets)
        var selectedAttribute;
        var $attributeContainers = $('.js-product-attribute-item');
        var selectableElementClass = 'js-attribute-value';
        var errorContainerSelector = '.js-add-to-cart-validation';
        var $errorContainer;
        var addToCartTxt;
        var product = response.product;
        var pickup = product.sourcingLocations.pickup || {};

        if (pickup.isSelected && !pickup.isPickupInStoreEnabled && product.available) {
            $('button.add-to-cart', response.$productContainer).addClass('disabled').attr('disabled','true');
            $(this).find('.c-product-attribute__header .js-add-to-cart-validation').removeClass('d-none');
            addToCartTxt = $('.st-product-detail__add-to-cart').data('addtocart');
            $('button.add-to-cart').text(addToCartTxt);
        } else if (product.readyToOrder && !product.available) {
            $('button.add-to-cart', response.$productContainer).addClass('disabled').attr('disabled','true');
            $(this).find('.c-product-attribute__header .js-add-to-cart-validation').removeClass('d-none');
            addToCartTxt = $('.st-product-detail__add-to-cart').data('oos');
            $('button.add-to-cart').text(addToCartTxt);
        } else {
            $('button.add-to-cart', response.$productContainer).removeClass('disabled').removeAttr('disabled');
            $(this).find('.c-product-attribute__header .js-add-to-cart-validation').addClass('d-none');
            addToCartTxt = $('.st-product-detail__add-to-cart').data('addtocart');
            $('button.add-to-cart').text(addToCartTxt);
        }
        $attributeContainers.each(function () {
            selectedAttribute = $(this).find('.selected, input:checked');
            if (selectedAttribute && selectedAttribute.hasClass(selectableElementClass)) {
                $errorContainer = $(this).find(errorContainerSelector);
                $errorContainer.addClass('d-none');
            } else {
                $errorContainer = $(this).find(errorContainerSelector);
                $errorContainer.removeClass('d-none');
            }
        });
    });
};

detailsBase.updateAvailability = function () {
    $('body').on('product:updateAvailability', function (e, response) {
        $('div.availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available);

        $('.availability-msg', response.$productContainer)
            .empty().html(response.message);

        if ($('.global-availability').not('.product-quickview .global-availability').length) {
            var allAvailable = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability')
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg').empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        }
    });
};

detailsBase.warranty = function () {
    var $warrantyContent = $('#warrantyModal');
    $('.js-warranty-content-link').on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        if (!$warrantyContent.length) {
            getModalHtmlElement('warrantyModal');
            $warrantyContent = $('#warrantyModal');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $warrantyContent.find('.modal-body').html(data.content);
                }
            });
        }
        $warrantyContent.modal('show');
    });

    $('body').on('click touchstart', function (e) {
        if ($('.js-warranty-content-link').has(e.target).length <= 0) {
            $warrantyContent.removeClass('active');
        }
    });
};

detailsBase.availability = baseModule.availability;
detailsBase.addToCart = baseModule.addToCart;
detailsBase.focusChooseBonusProductModal = baseModule.focusChooseBonusProductModal;

module.exports = detailsBase;
